// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { useSessionStorage } from "@jvs-group/jvs-mairistem-tools";
import { ApplicationFrameContext } from "../ApplicationFrame";
import { ApplicationLauncherContext } from "./ApplicationLauncherContext";

// eslint-disable-next-line max-len
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationLauncherContextProvider = props => {
  const {
    children
  } = props;
  const {
    Provider
  } = ApplicationLauncherContext;
  const {
    launcher: {
      open,
      setOpen
    }
  } = React.useContext(ApplicationFrameContext);
  const [visible, setVisible] = useSessionStorage("interaction.launcher.visible", true);
  return React.useMemo(() => /*#__PURE__*/_jsx(Provider, {
    value: {
      open,
      setOpen,
      visible,
      setVisible
    },
    children: children
  }), [children, open, visible, setOpen, setVisible]);
};